import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-853d75d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-search flex-col" }

import { t } from '@/plugins/i18n'
import { ref, toRaw, watch } from 'vue'
import { cloneDeep } from 'lodash'
import type { FormInstance } from 'element-plus'
import { clearForm, setDefaultForm } from '@/util/common'
import { channelEnum, productStatsEnum } from '../data'
import { isD2C, isMultiStore } from '@/store'
import { productSettlementStatus, settlementStatus, settlementStatus2 } from '../OrderList/data'


export default /*#__PURE__*/_defineComponent({
  props: ['form'],
  emits: ['update:form', 'refresh'],
  setup(__props, { emit: emits }) {

const props = __props
const orderRef = ref<FormInstance>()




const defaultForm = {
  productSku: '',
  platformOrderNo: '',
  productTitleJp: '',
  orderItemStatus: '',
  customerOrderNo: '',
  reachDelay: '',
  channel: '',
  settleStatus: '',
  goodsCountry: ''
}

const getForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultForm)
const _form = ref(getForm(props.form))
watch(() => props.form, (newValue) => {
  _form.value = getForm(newValue)
})

const submit = () => {
  const form = cloneDeep(toRaw(_form.value))
  form.customerProductMskuList && !(form.customerProductMskuList instanceof Array) && (form.customerProductMskuList = [form.customerProductMskuList])
  emits('update:form', form)
  emits('refresh')
}
const resetForm = () => {
  clearForm(_form.value)
  emits('update:form', cloneDeep(toRaw(_form.value)))
  emits('refresh')
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: (_value, _refs) => {
        _refs['orderRef'] = _value
        orderRef.value = _value
      },
      inline: true,
      model: _form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _unref(t)('客户商品sku'),
          prop: "customerProductMskuList"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.customerProductMskuList,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.customerProductMskuList) = $event)),
              maxlength: "100"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('平台商品SKU'),
          prop: "productSku"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.productSku,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_form.value.productSku) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('THE CKB订单编号'),
          prop: "platformOrderNo"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.platformOrderNo,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_form.value.platformOrderNo) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        (!_unref(isD2C)())
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: _unref(t)('订单标题'),
              prop: "customerOrderNo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.customerOrderNo,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_form.value.customerOrderNo) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_unref(isD2C)())
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: _unref(t)('商品名称'),
              prop: "productTitleJp"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.productTitleJp,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_form.value.productTitleJp) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('商品状态'),
          prop: "orderItemStatus"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _form.value.orderItemStatus,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_form.value.orderItemStatus) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: _unref(t)('全部'),
                  value: ""
                }, null, 8, ["label"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStatsEnum), (label, value) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: value,
                    label: label,
                    value: value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('业务类型'),
          prop: "channel"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _form.value.channel,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_form.value.channel) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: _unref(t)('全部'),
                  value: ""
                }, null, 8, ["label"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(channelEnum), (label, value) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: value,
                    label: label,
                    value: value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_unref(isD2C)())
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: _unref(t)('客户订单编号'),
              prop: "customerOrderNo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.customerOrderNo,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_form.value.customerOrderNo) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('到货延迟'),
          prop: "reachDelay"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _form.value.reachDelay,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_form.value.reachDelay) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: _unref(t)('是1'),
                  value: '1'
                }, null, 8, ["label"]),
                _createVNode(_component_el_option, {
                  label: _unref(t)('否1'),
                  value: '0'
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('结算状态'),
          prop: "preferDeliverFlag"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _form.value.settleStatus,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_form.value.settleStatus) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: _unref(t)('全部'),
                  value: ""
                }, null, 8, ["label"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productSettlementStatus), (label, value) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: value,
                    label: label,
                    value: value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_unref(isMultiStore)())
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: _unref(t)('商品所在地'),
              prop: "goodsCountry"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _form.value.goodsCountry,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_form.value.goodsCountry) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('全部'),
                      value: ""
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('中国'),
                      value: "CN"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('韩国'),
                      value: "KR"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "warning",
              onClick: submit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "text",
              onClick: resetForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})